<template>
  <div>
    <div class="navgition-wrapper">
      <!-- 筛选栏目 -->
      <!--地区分布-->
      <div class="selectList" v-if="areaNavList">
        <!-- 默认 -->
        <div class="cluster">
          <div class="left">
            地区分布:
          </div>
          <div class="right">
            <span class="expanded" v-show="areaNavList.length > 1" @click="handleAreaFirMore($event)">更多</span>
          </div>
        
          <!--主体部分-->
          <div v-for="(itemArrs, index) of areaNavList"
              :key="index" :name="index">
            <ul class="cluster-more" v-show =(!index) v-if="itemArrs">
              <li v-for="(item, indexChild) of itemArrs"
                  :title="item.value"
                  :key="indexChild" :name="indexChild"
                  :class="{'before-traggle': item.subdata.length > 0 && overAreaCurrentIndex === indexChild && overCurrentRow == index, 'select' : overAreaCurrentIndex === indexChild && overCurrentRow == index}"
                  @mouseover="handleMouseAreaFir($event, index, indexChild)"
                  @click="handleAddAreaFir(item.value, $event)"
                  
                  >{{item.value | ellipsis}}<span v-if="item.subdata.length > 0"></span>
              </li>
            </ul>
            <!-- 插入 -->
            <div class="insertItems" v-show="false" v-if="itemArrs">
              <ul class="ItemInsert clear"  
                  v-for="(CountryArrs, index) of itemArrs"
                  :key="index"
                  :name="index"
                  v-show = "false"
                  >
                <li v-for="(countryArr, index) of CountryArrs.subdata"
                    :title="countryArr.value"
                    :key="index"
                    @click="handleAddAreaSec(countryArr.value, $event)"
                    @mouseover="handleMouseAreaSec($event, index)"
                    :class= "{selectSec: overAreaInsertCurrentIndex === index}"
                    >{{countryArr.value}}</li>
                <span class="insertExpand" v-show="CountryArrs.subdata.length > 11" @click="expandAreaMore($event)">更多</span>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--专题分类-->
      <div class="selectList" v-if="topicNavList">
        <!-- 默认 -->
        <div class="topic">
          <div class="left">
            专题分类:
          </div>
          <div class="right">
            <span class="expanded topic-expand" v-show="topicNavList.length > 1" @click="handleTopicFirMore($event)">更多</span>
          </div>
        
          <!--主体部分-->
          <div v-for="(itemArrs, index) of topicNavList"
              :key="index" :name="index">
              
              <!--v-show =(!index)>  -->
            <ul class="cluster-more-topic" v-show =(!index)>
              <li v-for="(item, indexChild) of itemArrs"
                  :title="item.value"
                  :class="{'before-traggle': item.subdata.length > 0 && overTopicCurrentIndex === indexChild && overCurrentTopicRow == index, 'select' : overTopicCurrentIndex === indexChild  && overCurrentTopicRow == index}"
                  :key="indexChild" :name="indexChild"
                  @click="handleAddTopicFir(item.value, $event)"
                  @mouseover="handleMouseTopicFir($event, index, indexChild)"
                  >{{item.value}}</li>
            </ul>
            <!-- 插入 -->
            <div class="insertItems" v-show="false">
              <ul class="ItemInsert clear" 
                  v-for="(CountryArrs, index) of itemArrs"
                  :key="index"
                  :name="index"
                  v-show = "false"
                  >
                <li v-for="(countryArr, index) of CountryArrs.subdata"
                    :title="countryArr.value"
                    :class="{selectSec : overTopicInsertCurrentIndex === index}"
                    :key="index"
                    @click="handleAddTopicSec(countryArr.value, $event)"
                    @mouseover="handleMouseTopicSec($event, index)"
                    >{{countryArr.value}}</li>
                <span class="insertExpandTopic" v-show="CountryArrs.subdata.length > 11" @click="expandTopicMore($event)">更多</span>
              </ul>
              
            </div>
          </div>
        </div>
      </div>
      <!--筛选组合-->
      <div>
      <div class="screening clear" v-if="areaNavList && topicNavList">
        <div class="left">
          筛选组合:
        </div>
        <ul>
          <li v-for="(item, index) of filterShowList"
            :key="index"
          >{{item}}<span class="iconfont closeBtn"
                        @click="removeFilter(index, item)"
                      >&#xe6f0;</span></li>
        </ul>
      </div>
      </div>
    </div>
    <ContentArea :queryCondition="queryCondition" :filterSearchList="filterSearchList" :queryInfo="queryInfo"></ContentArea>
  </div>
</template>

<script>
import $ from 'jquery'
import ContentArea from '@/common/ContentArea'
import Pagination from '@/common/Pagination'
import {reqSearch} from '../../api'
import {mapState} from 'vuex'
export default {
  name: 'Search',
  components: {
    ContentArea,
    Pagination
  },
  props: {
    queryInfo: String
  },
  data () {
    return {
      province: '',
      county: '',
      resultData: {},
      queryCondition: [],
      areaNavList: [],
      topicNavList: [],
      areaList: [],
      topicList: [],
      curPage: 1,
      filterAreaArrs: [],
      filterTopicArrs: [],
      titleFlag: true,
      titleFlag1: true,
      flag : true,
      flag1 : true,
      filterSearchList: [],
      overAreaCurrentIndex: -1,
      overTopicCurrentIndex: -1,
      overAreaInsertCurrentIndex: -1,
      overTopicInsertCurrentIndex: -1,
      overCurrentRow: -1,
      overCurrentTopicRow: -1,
      queryObjecet: {} //URL 查询参数
    }
  },
  filters: {
    ellipsis(value) {
      if (!value) return;
      if (value.length > 5) {
        return value.slice(0, 5) + "...";
      }
      return value;
    }
  },
  computed: {
    ...mapState(['filterShowList', 'filterQueryist'])
  },
  methods: {
    // 数组去重
    ArrayFilter (arr) {
      let list = Array.from(new Set(arr))
      return list
    },
    // 截取数据
    InterceptionArr (arr) {
      if(!arr) {
        return
      }
      const Arrs = []
      arr.forEach((item,index) => {
        const Arr = Math.floor(index/9)
        if(!Arrs[Arr]) {
          Arrs[Arr] = []
        }
        Arrs[Arr].push(item)
      })
      return Arrs
    },
    InterceptionArrTopic (arr) {
      if(!arr) {
        return
      }
      const Arrs = []
      arr.forEach((item,index) => {
        const Arr = Math.floor(index/9)
        if(!Arrs[Arr]) {
          Arrs[Arr] = []
        }
        Arrs[Arr].push(item)
      })
      return Arrs
    },
    _initPage () {
    },
    // 检索导航数据聚类
    async handleAreaNavData(opt) {
      const result =  await reqSearch(opt)
      const data = result.resulter // 获取对象resulter
      if(data){
        this.areaNavList = this.InterceptionArr(JSON.parse(data.facetPivot))
      }
      this.hit = data.hit;
     
    },
    async handleTopicNavData(opt) {
      const result =  await reqSearch(opt)
      const data = result.resulter // 获取对象resulter
      if(data) {
        this.topicNavList = this.InterceptionArrTopic(JSON.parse(data.facetPivot))
      }
      this.hit = data.hit;
    },
    async handleAreaListData(opt) {
      const result =  await reqSearch(opt)
      const data = result.resulter // 获取对象resulter
      this.topicNavList = JSON.parse(data.results)
      this.hit = data.hit;
    },
    
    async handleTopicListData(opt) {
      const result =  await reqSearch(opt)
      const data = result.resulter // 获取对象resulter
      this.topicList = JSON.parse(data.results)
      this.hit = data.hit;
    },

    handleCurrentChangeSub (val) {
      this.curPage = val
    },
    async handleAddAreaFir(val, e) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.filterAreaArrs = this.filterShowList
        this.filterSearchList = this.filterQueryist
        this.filterAreaArrs.push('地区分布:' + val)
        this.$store.dispatch('savaFilterList', this.ArrayFilter(this.filterAreaArrs))
        this.filterSearchList.push('Province:' + val)
        this.$store.dispatch('savaFilterQuery', this.ArrayFilter(this.filterSearchList))
        //this.$router.replace({path: 'search',query: {}})
      }
    },
    // 滑过展开添加样式
    handleMouseAreaFir (e, index, indexChild) {
      // 展开收起逻辑
      var $this = $(e.target)
      //$this.children().toggle();
      var name = $this.attr("name")
      var ulN =$this.parent().next().children('ul[name ='+name+']');
      var state = ulN.css("display"); // block none
      if ( state === "block") {
        $this.parent().next().show();
        $this.parent().next().children('ul[name ='+name+']').toggle();
        $this.parent().next().toggle();
      }else {
        $this.parent().next().hide();
        $this.parent().next().children('ul[name ='+name+']').hide();
      }
      $this.parent().next().children('ul[name ='+name+']').siblings("ul").hide();
      $this.parent().next().children('ul[name ='+name+']').toggle();
      // 添加样式
      $('.cluster .insertItems').hide()
      $this.parent().next().show()
      $this.parent().next().children('ul[name ='+name+']').show()
      // 二级没有数据不展示
      let lengthLi = $this.parent().next().children('ul[name ='+name+']').children().length
      if(lengthLi <= 1) {
        $this.parent().next().children('ul[name ='+name+']').hide();
        $this.parent().next().hide()
      }
      this.overAreaCurrentIndex = indexChild
      this.overCurrentRow =  $this.parent().parent().attr('name')
    },

    async handleAddAreaSec(val, e) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.filterAreaArrs = this.filterShowList
        this.filterSearchList = this.filterQueryist

        var $this = $(e.target)
        var secNameIndex = $this.parent().attr('name')
        //.children('ul[name ='+secNameIndex+']').attr('title')
        var firTitleName = $this.parent().parent().prev().children('li').eq(secNameIndex).attr('title')
        // 过滤
        if (this.filterAreaArrs.length > 0) {
          this.filterAreaArrs.forEach((item, index) => {
            if (item.split(':')[1] == firTitleName) {
              const newArr = '地区分布:' + item.split(":")[1] + '-' + val
              const newArrS = 'City:' + firTitleName + '#' + val
              //const newArr = item+ '-' + val
              this.filterAreaArrs.splice(index, 1, newArr)
              this.filterSearchList.splice(index, 1, newArrS)
              //this.filterSearchList.push ('City:' + val)
            } else {
              this.filterAreaArrs.push('地区分布:' + firTitleName + '-' + val)
              //this.filterSearchList.push ('Province:' + firTitleName)
              //this.filterSearchList.push ('City:' + val)
              this.filterSearchList.push(`City:${firTitleName}#${val}`)
            }
          })
        } else {
          this.filterAreaArrs.push('地区分布:' + firTitleName + '-' + val)
          //this.filterSearchList.push ('Province:' + firTitleName)
          //this.filterSearchList.push ('City:' + val)
          this.filterSearchList.push(`City:${firTitleName}#${val}`)
        }
        this.$store.dispatch('savaFilterList', this.ArrayFilter(this.filterAreaArrs))
        this.$store.dispatch('savaFilterQuery', this.ArrayFilter(this.filterSearchList))
      }
    },
    handleMouseAreaSec (e, index) {
      this.overAreaInsertCurrentIndex = index
    },
    async handleAddTopicFir(val, e) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.filterAreaArrs = this.filterShowList
        this.filterSearchList = this.filterQueryist
        this.filterAreaArrs.push('专题分类:' + val)
        this.filterSearchList.push('CategoryA:' + val)
        this.$store.dispatch('savaFilterList', this.ArrayFilter(this.filterAreaArrs))
        this.$store.dispatch('savaFilterQuery', this.ArrayFilter(this.filterSearchList))
      }
    },
    handleMouseTopicFir (e, index, indexChild) {
      var $this = $(e.target)
      var name = $this.attr("name")
      var ulN =$this.parent().next().children('ul[name ='+name+']');
      var state = ulN.css("display"); // block none
      if ( state === "block") {
        $this.parent().next().show();
        $this.parent().next().children('ul[name ='+name+']').toggle();
        $this.parent().next().toggle();
      }else {
        $this.parent().next().hide();
        $this.parent().next().children('ul[name ='+name+']').hide();
      }
      $this.parent().next().children('ul[name ='+name+']').siblings("ul").hide();
      $this.parent().next().children('ul[name ='+name+']').toggle();
      $('.topic .insertItems').hide()
      $this.parent().next().show()
      $this.parent().next().children('ul[name ='+name+']').show()
      // 二级没有数据不展示
      let lengthLi = $this.parent().next().children('ul[name ='+name+']').children().length
      if(lengthLi <= 1) {
        $this.parent().next().children('ul[name ='+name+']').hide();
        $this.parent().next().hide()
      }
      this.overTopicCurrentIndex = indexChild
      this.overCurrentTopicRow =  $this.parent().parent().attr('name')
    },
    async handleAddTopicSec(val, e) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.filterAreaArrs = this.filterShowList
        this.filterSearchList = this.filterQueryist
        var $this = $(e.target)
        var secNameIndex = $this.parent().attr('name')
        //.children('ul[name ='+secNameIndex+']').attr('title')
        var firTitleName = $this.parent().parent().prev().children('li').eq(secNameIndex).attr('title')
        // 过滤
        if (this.filterAreaArrs.length > 0) {
          this.filterAreaArrs.forEach((item, index) => {
            if (item.split(':')[1] == firTitleName) {
              const newArr = '专题分类:' + item.split(":")[1] + '-' + val
              const newArrS = 'CategoryB:' + firTitleName + '#' + val
              this.filterAreaArrs.splice(index, 1, newArr)
              this.filterSearchList.splice(index, 1, newArrS)
              //this.filterSearchList.push (`CategoryB:${firTitleName}#${val}`)
            } else {
              this.filterAreaArrs.push('专题分类:' + firTitleName + '-' + val)
              this.filterSearchList.push(`CategoryB:${firTitleName}#${val}`)
            }
          })
        } else {
          this.filterAreaArrs.push('专题分类:' + firTitleName + '-' + val)
          this.filterSearchList.push(`CategoryB:${firTitleName}#${val}`)
        }
        this.$store.dispatch('savaFilterList', this.ArrayFilter(this.filterAreaArrs))
        this.$store.dispatch('savaFilterQuery', this.ArrayFilter(this.filterSearchList))
      }
    },
    handleMouseTopicSec (e, index) {
      this.overTopicInsertCurrentIndex = index
    },
    removeFilter (index, value) {
      this.filterAreaArrs = this.filterShowList
      this.filterSearchList = this.filterQueryist

      // if(this.filterShowList[index].indexOf("-") !== -1) {
      //   let arrs = this.filterShowList[index].split(":")[1].split("-")
      //   this.filterQueryist.forEach ( (item, index) => {
      //     if (item.split(":")[1].split('#')[0] == arrs[0]) {
      //       this.filterQueryist.splice(index, 1)
      //     }
      //   })
      //   this.filterQueryist.forEach ( (item, index) => {
      //   if (item.split(":")[1].split('#')[1] == arrs[1]) {
      //     this.filterQueryist.splice(index, 1)
      //   }
      //   })
      //   this.filterShowList.splice(index,1)
      //   //this.filterQueryist.splice(index,2)
      // }else {
      //   let arr = this.filterShowList[index].split(":")[1]
      //   console.log(arr)
      //   this.filterQueryist.forEach ( (item, index) => {
      //     if (item.split(":")[1] === arr) {
      //       this.filterQueryist.splice(index, 1)
      //     }
      //   })
      //   this.filterShowList.splice(index,1)
      // }

      this.filterQueryist.splice(index, 1)
      this.filterShowList.splice(index,1)
      // this.filterShowList.splice(index,1)
      // this.filterQueryist.splice(index, 1)
      this.$store.dispatch('savaFilterList', this.filterShowList)
      this.$store.dispatch('savaFilterQuery', this.filterQueryist)
    },
    // 展开地区一级分类更多
    handleAreaFirMore (e) {
      var $this = $(e.target)
      $('.cluster > div:gt(2)').show(500)
      $(".cluster > div[name='0'] > ul").show(500);
      if(!this.titleFlag) {
        //收起是执行的逻辑
        $('.cluster > div:gt(2)').hide(500)
        var arrSecitem = $('.cluster > div:gt(2)')
        for(var i=0;i<arrSecitem.length;i++) {
          $('.cluster > div:gt(2)').eq(i).children('div').last().hide(500)
          $('.cluster > div:gt(2)').eq(i).children('ul').last().children('li').removeClass("select")
          $('.cluster > div:gt(2)').eq(i).children('ul').last().children('li').children('span').removeClass("traggle")
        }
      }
      else {
        var arrSecitem = $('.cluster > div:gt(2)')
        for(var i=0;i<arrSecitem.length;i++) {
          $('.cluster > div:gt(2)').eq(i).children('ul').last().show(500)
        }
      }
      !this.titleFlag ? $this.text("更多") :  $this.text("收起")
      this.titleFlag = !this.titleFlag

    },
    // 展开专题一级分类更多
    handleTopicFirMore (e) {
      var $this = $(e.target)
      $('.topic > div:gt(2)').show(500)
      $(".topic > div[name='0'] > ul").show(500);
      // $('.insertItems').hide()
      if(!this.titleFlag1) {
        //收起是执行的逻辑
        $('.topic > div:gt(2)').hide(500)
        var arrSecitem = $('.topic > div:gt(2)')
        for(var i=0;i<arrSecitem.length;i++) {
          //arrSecitem.eq(i).children('div').last()
          $('.topic > div:gt(2)').eq(i).children('div').last().hide(500)
          $('.topic > div:gt(2)').eq(i).children('ul').last().children('li').removeClass("select")
          $('.topic > div:gt(2)').eq(i).children('ul').last().children('li').children('span').removeClass("traggle")
        }
      }
      else {
        var arrSecitem = $('.topic > div:gt(2)')
        for(var i=0;i<arrSecitem.length;i++) {
          $('.topic > div:gt(2)').eq(i).children('ul').last().show(500)
        }
      }
      !this.titleFlag1 ? $this.text("更多") :  $this.text("收起")
      this.titleFlag1 = !this.titleFlag1
      
    },
    //展开地区二级更多
    expandAreaMore (e) {
      if(!this.flag) {
        $('.cluster > div:gt(2)').removeClass("select")
        $('.cluster > div:gt(2)').removeClass("traggle")
        $('.cluster > div:gt(2)').removeClass("selectSec")
      }
      var $this = $(e.target)
      var autoHeight = $this.parent().css("height", "auto").height();
      this.flag ? $this.parent().height("36px").animate({"height": autoHeight}, 300) :  $this.parent().height(autoHeight).animate({"height":"36px"}, 300)
      //this.flag ? $this.parent().css("height","auto") :  $this.parent().css("height","36px")
      !this.flag ? $this.text("更多") :  $this.text("收起")
      this.flag = !this.flag
    },
    //展开专题二级更多
    expandTopicMore (e) {
      if(!this.flag1) {
        $('.topic > div:gt(2)').removeClass("select")
        $('.topic > div:gt(2)').removeClass("traggle")
        $('.topic > div:gt(2)').removeClass("selectSec")
      }
      var $this = $(e.target)
      var autoHeight = $this.parent().css("height", "auto").height();
      this.flag1 ? $this.parent().height("36px").animate({"height": autoHeight}, 300) :  $this.parent().height(autoHeight).animate({"height":"36px"}, 300)
      !this.flag1 ? $this.text("更多") :  $this.text("收起")
      this.flag1 = !this.flag1
    },
    // 刷新页面，读取路由，渲染页面
    _initRoute() {
      const keyWord = this.$route.query.query
      let optArea = {}
      let optTopic = {}
      if (keyWord) {
        optArea = {
          query: keyWord,
          facetPivot: ['Province', 'City']
        }
        optTopic = {
          query: keyWord,
          facetPivot: ['CategoryA', 'CategoryB']
        }
      }else{
        optArea = {
          query: "",
          facetPivot: ['Province', 'City']
        }
        optTopic = {
          query: "",
          facetPivot: ['CategoryA', 'CategoryB']
        }
      }
      this.handleAreaNavData(optArea)
      this.handleTopicNavData(optTopic)
    }
    
  },
  mounted() {
    this.$loginAuthentication.intercept(0);
    if(this.filterShowList.length > 0) {
      this.filterAreaArrs.push(this.filterShowList[0])
    }
    if(this.filterQueryist.length > 0) {
      this.filterSearchList.push(this.filterQueryist[0])
    }
  },
  watch: {
    // 动态监视路由query变化 //实时聚类
    $route: {
      handler(val) {
        this.$loginAuthentication.intercept(0);
        this._initRoute()
      },
      deep: true
    }
  },
   created() {
    this._initRoute()
  }
}
</script>

<style lang="less" scoped>
.screening {
  width: 1200px;
  margin: 0 auto;
  //padding-bottom: 10px;
  //float: left;
  div {
    width: 100px;
    float: left;
    //padding-top: 20px;
    padding-top: 10px;
    padding-bottom: 10px
  }
  ul {
    width: 1100px;
    display: inline-block;
    //padding: 10px 0;
    li {
      float: left;
      box-sizing: border-box;
      //width: 146px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #b27350;
      padding-left: 12px;
      font-size: 14px;
      //text-align: center;
      vertical-align: middle;
      //margin-right: 10px;
      margin:5px 0;
      margin-right: 10px;
      color:  #b27350;
      .closeBtn {
        height: 30px;
        line-height: 30px;
        color: #b27350;
        margin: 0 10px;
        cursor: pointer;
      }
    }
  }
}
.navgition-wrapper {
  background: #fbf9f8;
  .left {
    font-size: 16px;
   
  }
}
.selectList .topic ul li {
  width: 113px;
}
.select 
  {
    background: url(~imgs/topicSelectBg.png) no-repeat;
    background-size: 100% 100%;
  }
.selectList{
  width: 1200px;
  margin: 0 auto;
  border-bottom: 1px dotted #e2d7d1;
  padding-bottom: 17px;
  color: #94491f;
  .cluster, .topic {
    width: 1200px;
    margin: 0 auto;
    padding-top: 10px;
    overflow: hidden;
    position: relative;
    .cluster-more-topic {
      li {
        width: 113px;

      }
      li.select {
        background: url(~imgs/topicSelectBg.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    ul {
      display: block;
      // width: 1100px;
       width: 1064px;
        li {
          text-align: center;
          font-size: 14px;
          height: 36px;
          line-height: 36px;
          width: 113px;
          color: #a31f24;
          float: left;
          cursor: pointer;
          // display: inline-block;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          // overflow: hidden;
          // display: inline-block;
        }
        .select {
          background: url(~imgs/topicSelectBg.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    .right {
      width: 100px;
      float: right;
      height: 36px;
      text-align: center;
      line-height: 36px;  
      cursor: pointer;
      position: absolute;
      right: 0;
    }
    .center {
      width: 1000px;
      float: left;
      ul {
        height: 36px;
        overflow: hidden; // 11个元素
      }
    }
    .left {
      width: 100px;
      float: left;
      height: 36px;
      line-height: 36px;
      position: absolute;
    }
  }
  .insertExpand, .insertExpandTopic {
    position: absolute;
    top: 9px;
    right: -62px;
    font-size: 13px;
    }
  .insertItems {
    width: 1100px;
    display: inline-block;
    //top: 10px;
    position: relative;
    cursor: pointer;
  }
  .ItemInsert {
    margin-left: 100px;
    height: 36px;
    width: 1000px;
    overflow: hidden;
    background: #dfdbd9;
    //height: 36px;;
    //margin: 10px 0;
    padding-right: 100px;
    li {
      float: left;
      width: 113px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 13px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .cluster-more,.cluster-more-topic {
    margin-left: 100px;
    width: 1000px;
    height: 36px;
    overflow: hidden;
    color: #a31f24;
    cursor: pointer;
    padding-bottom: 10px;
    li {
      position: relative;
      float: left;
      width: 90px;
      height: 36px;
      text-align: center;
      line-height: 36px;
    }
    .before-traggle::after {
          position: absolute;
          content: '';
          top: 36px;
          left: 47px;
          border-right: 10px solid transparent;
          border-left: 10px solid transparent;
          border-bottom: 10px solid #dfdbd9;
        }
  }
}
.showTraggle::after {
  content: '';
  //display: block;
  position: relative;
  top: 10px;
  left: -22px;
  margin-left: -10px;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  border-bottom: 10px solid #dfdbd9;
}
.hideTraggle::after {
  content: '';
  //display: none;
  position: relative;
  top: 10px;
  left: -22px;
  margin-left: -10px;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  border-bottom: 10px solid #dfdbd9;
}
.combination {
  .left {
    height: 30px;
    line-height: 30px;
    text-align: center;
    width: 100px;
    float: left;
    padding-top: 16px;
  }
  .center {
    width: 1100px;
    float: left;
    ul {
      float: left;
      display: block;
      padding-top: 14px;
        li {
          text-align: center;
          font-size: 16px;
          height: 36px;
          line-height: 36px;
          color: #b27350;
          float: left;
          padding: 0 10px;
        }
        .select {
          border: 1px solid #b27350;
        }
      }
    }
}
.left {
font-size: 16px;
color: #333;
}
.selectSec {
  font-weight: bold;
}
.expanded  {
  font-size: 13px;
}
.selectList {
  .topic {
    ul {
      li {
        width: 113px;
      }
    }
  }
}
.selectList {
  .cluster, .topic {
    .insertItems {
      ul.ItemInsert  {
        li {
          font-size: 13px;
        }
        
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/search/Search.vue